import { jsxs as x, jsx as n } from "react/jsx-runtime";
import { forwardRef as C, useId as j, useState as D, useRef as z, useCallback as v } from "react";
import { X as B } from "lucide-react";
const A = {
  neutral: {
    bg: "var(--neutral-bg)",
    border: "var(--neutral-border)",
    text: "var(--text-primary)",
    hover: "var(--bg-hover)"
  },
  accent: {
    bg: "var(--accent-dim)",
    border: "var(--accent-border)",
    text: "var(--text-primary)",
    hover: "var(--accent-dim)"
  },
  warning: {
    bg: "var(--warning-bg)",
    border: "var(--warning-border)",
    text: "var(--text-primary)",
    hover: "var(--warning-bg)"
  },
  error: {
    bg: "var(--error-bg)",
    border: "var(--error-border)",
    text: "var(--text-primary)",
    hover: "var(--error-bg)"
  }
}, _ = C(function({
  value: t,
  onChange: o,
  placeholder: b,
  accent: y = "neutral",
  chipIcon: f,
  addButtonLabel: g,
  "aria-label": s,
  invalid: c = !1,
  disabled: e = !1,
  dedupe: m = !0,
  className: w,
  removeAriaLabel: h
}, k) {
  const R = `${j()}-chip-input`, [i, l] = D(""), $ = z(null), d = A[y], p = v(
    (r) => {
      const a = r.trim();
      if (a) {
        if (m && t.includes(a)) {
          l("");
          return;
        }
        o([...t, a]), l("");
      }
    },
    [m, o, t]
  ), u = v(
    (r) => {
      if (e) return;
      const a = t.slice();
      a.splice(r, 1), o(a);
    },
    [e, o, t]
  ), I = v(
    (r) => {
      if (!e) {
        if (r.key === "Enter" || r.key === ",") {
          r.preventDefault(), p(i);
          return;
        }
        r.key === "Backspace" && i.length === 0 && t.length > 0 && (r.preventDefault(), u(t.length - 1));
      }
    },
    [p, e, i, u, t.length]
  ), S = {
    minHeight: "var(--space-8)",
    padding: "var(--space-1)",
    background: "var(--bg-elevated)",
    border: `1px solid var(${c ? "--error-border" : "--border-default"})`,
    borderRadius: "var(--radius-lg)",
    cursor: e ? "not-allowed" : "text",
    opacity: e ? 0.6 : 1
  };
  return /* @__PURE__ */ x(
    "div",
    {
      ref: k,
      role: "group",
      "aria-label": s,
      "aria-disabled": e || void 0,
      className: ["ls-chip-input", "flex flex-wrap items-center", w].filter(Boolean).join(" "),
      style: { ...S, gap: "var(--space-1)" },
      "data-invalid": c || void 0,
      children: [
        /* @__PURE__ */ n(
          "ul",
          {
            "aria-label": `${s} chips`,
            className: "contents",
            style: { margin: 0, padding: 0, listStyle: "none" },
            children: t.map((r, a) => /* @__PURE__ */ x(
              "li",
              {
                className: "inline-flex items-center",
                style: {
                  gap: "var(--space-1)",
                  paddingInline: "var(--space-2)",
                  paddingBlock: "var(--space-0_5)",
                  background: d.bg,
                  border: `1px solid ${d.border}`,
                  borderRadius: "var(--radius-pill)",
                  color: d.text,
                  fontSize: "var(--text-xs)",
                  fontWeight: 500,
                  lineHeight: 1.4
                },
                "data-chip": !0,
                children: [
                  f ? /* @__PURE__ */ n("span", { "aria-hidden": !0, style: { display: "inline-flex" }, children: f }) : null,
                  /* @__PURE__ */ n("span", { children: r }),
                  /* @__PURE__ */ n(
                    "button",
                    {
                      type: "button",
                      onClick: (N) => {
                        N.stopPropagation(), u(a);
                      },
                      disabled: e,
                      "aria-label": h ? h(r) : `Remove ${r}`,
                      className: "ls-focus-ring inline-flex items-center justify-center",
                      style: {
                        width: "var(--icon-sm)",
                        height: "var(--icon-sm)",
                        color: "var(--text-secondary)",
                        background: "transparent",
                        border: "none",
                        borderRadius: "var(--radius-full)",
                        cursor: e ? "not-allowed" : "pointer",
                        padding: 0
                      },
                      "data-chip-remove": !0,
                      children: /* @__PURE__ */ n(B, { "aria-hidden": !0, style: { width: "var(--icon-xs)", height: "var(--icon-xs)" } })
                    }
                  )
                ]
              },
              `${r}-${a}`
            ))
          }
        ),
        /* @__PURE__ */ n(
          "input",
          {
            id: R,
            ref: $,
            type: "text",
            value: i,
            onChange: (r) => l(r.target.value),
            onKeyDown: I,
            onBlur: () => {
              i.trim() && p(i);
            },
            placeholder: b,
            disabled: e,
            "aria-label": `${s} input`,
            "aria-invalid": c || void 0,
            className: "ls-focus-ring",
            style: {
              flex: "1 1 auto",
              minWidth: "var(--space-12)",
              padding: "var(--space-1) var(--space-2)",
              color: "var(--text-primary)",
              background: "transparent",
              border: "none",
              fontSize: "var(--text-md)",
              fontFamily: "var(--font-sans)",
              outline: "none"
            },
            "data-chip-input-draft": !0
          }
        ),
        g ? /* @__PURE__ */ n(
          "span",
          {
            "aria-hidden": !0,
            style: {
              color: "var(--text-tertiary)",
              fontSize: "var(--text-xs)",
              paddingInline: "var(--space-1)"
            },
            children: g
          }
        ) : null
      ]
    }
  );
});
export {
  _ as C
};
//# sourceMappingURL=ChipInput-Km7_vxas.js.map
